import { SYNC_KEY_PROYECTOS_NUCLEOS } from "../../../constantes";
import { NucleoProyectoItem, ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { NucleoResponse } from "../../../shared/response/proyectos/NucleoResponse";
import { ServiceGetListBase } from "../../../shared/services/base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Núcleos (agrupación asociativa de beneficiarios cercanos) (`ProyectosPlataformaService`, gRPC). */
export class NucleoService extends ServiceGetListBase<NucleoResponse> {
  static readonly instance = new NucleoService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_PROYECTOS_NUCLEOS;
  protected readonly sortBy = "nombre";

  /** gRPC-Web (`ListNucleos`): no eliminados, con sus nombres relacionados y el total de proyectos. */
  protected async fetchItems(): Promise<NucleoResponse[]> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).listNucleos({}));
    return r.items.map(toNucleoResponse);
  }
}

/** Mensaje gRPC del núcleo → `NucleoResponse`. Lo reusa el guardado. */
export function toNucleoResponse(n: NucleoProyectoItem): NucleoResponse {
  return {
    id: n.id,
    isEliminado: false,
    nombre: n.nombre,
    region: n.region,
    cultivoId: n.cultivoId ?? null,
    cultivoNombre: n.cultivoNombre ?? null,
    tecnicoId: n.tecnicoId ?? null,
    tecnicoNombre: n.tecnicoNombre ?? null,
    macroProyectoId: n.macroProyectoId ?? null,
    macroProyectoNombre: n.macroProyectoNombre ?? null,
    haMaxAsociacion: n.haMaxAsociacion ?? null,
    montoMaxReferencial: n.montoMaxReferencial !== undefined ? Number(n.montoMaxReferencial) : null,
    totalProyectos: n.totalProyectos,
    createdAt: Number(n.createdAt),
  };
}
